/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Scores_TitleInputs */

const cs_clients_scores_title = /** @type {(inputs: Clients_Scores_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skóre leadu`)
};

const en_clients_scores_title = /** @type {(inputs: Clients_Scores_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead scores`)
};

/**
* | output |
* | --- |
* | "Lead scores" |
*
* @param {Clients_Scores_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_scores_title = /** @type {((inputs?: Clients_Scores_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Scores_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_scores_title(inputs)
	return cs_clients_scores_title(inputs)
});